import CopyToClipboard from 'components/CopyToClipboard';
import LinkButton from 'components/LinkButton';
import NavigationTabs from 'components/Navigation/NavigationTabs';
import SectionHeader from 'components/SectionHeader';
import {H2, H3, H4} from 'components/Typography';
import {useBackend} from 'state/backend';
import {jt, t} from 'ttag';
import {Backend} from 'types/api';

const CLOUD_BUYER_RICOH_LINK = 'https://cloud.buyer.digital.ricoh.com/';

export type RicohTradeAutomationBackendData = Backend<{
    invitationLink: string;
}>;

const RicohTradeAutomation = () => {
    const {
        data: {invitationLink},
    } = useBackend<RicohTradeAutomationBackendData>();

    const link = (
        <a
            aria-label="find-out-more-link"
            href="https://www.ricoh.co.jp/service/trade-automation"
            key={0}
            rel="noreferrer"
            target="_blank"
        >
            {t`here`}
        </a>
    );

    return (
        <>
            <NavigationTabs.Partner selection="integrations" />
            <SectionHeader
                subtitle={t`Import MakeLeaps invoices, associate them automatically to orders, and output bookkeeping/payment data.`}
                title={t`RICOH Trade Automation`}
            />
            <H2>{t`For RICOH Trade Automation users`}</H2>
            <H3>{t`Log in to RICOH Trade Automation`}</H3>
            <LinkButton
                aria-label="go-to-the-app-button"
                className="mb-2 mt-4"
                href={CLOUD_BUYER_RICOH_LINK}
                kind="primary"
                size="sm"
                target="_blank"
            >
                {t`Go to the App`}
            </LinkButton>
            <H3>{t`Sign-up page for your vendors`}</H3>
            <p>{t`You can invite vendors who don't have a MakeLeaps account to our Starter Plan. Invite them by sending a special signup link, which can be copied from the following button.`}</p>
            <CopyToClipboard className="my-2" size="sm" value={invitationLink}>
                {t`Copy Signup Link`}
            </CopyToClipboard>
            <H4>{t`What's special about the Starter plan`}</H4>
            <ul>
                <li>{t`Use a limited set of MakeLeaps features free of charge`}</li>
                <li>{t`Issue documents such as Order Confirmation and Invoice`}</li>
                <li>{t`Combine Invoices`}</li>
            </ul>
            <hr />
            <H2>{t`For those thinking about RICOH Trade Automation`}</H2>
            <p>{t`With RICOH Trade Automation (sold separately), you connect to MakeLeaps and can digitize purchasing, invoice processing, and the workflow between you and your vendors.`}</p>
            <H4>{t`Import the invoices from your MakeLeaps Secure Inbox to Trade Automation and do the following:`}</H4>
            <ul>
                <li>{t`View a list of your Invoices`}</li>
                <li>{t`View Invoice details`}</li>
                <li>{t`Automatically link Invoices to Orders you sent via MakeLeaps`}</li>
                <li>{t`Input bookkeeping information for your Invoices`}</li>
                <li>{t`Export Invoice, accounting, and payment data (CSV)`}</li>
            </ul>
            <p>
                {jt`Find out more ${link} about the product and arrange a demonstration or trial.`}
            </p>
        </>
    );
};

export default RicohTradeAutomation;
